import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import axios from 'axios'
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import CardColumns from 'react-bootstrap/CardColumns';
import Button from 'react-bootstrap/Button';

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      players: []
    }
  }
  componentDidMount() {
    axios.get(process.env.REACT_APP_API + '/api/players')
      .then(json => this.setState({ players: json.data }))
      .catch(error => alert(error))
  }
  render() {
    const { players } = this.state
    return (
        <CardColumns>
          {players.map(player => <Card>
            <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/players/' + player.id + '.jpg'} />
            <Card.Body>
              <Card.Title>{player.givenName} {player.surname}</Card.Title>
              <Card.Text>
                Some quick example text to build on the card title and make up the bulk of
                the card's content.
    </Card.Text>
              <Button variant="primary" href={`/players/${player.id}`}>{player.givenName} {player.surname}</Button>
            </Card.Body>
          </Card>)}
        </CardColumns>
    );
  }
}

export default Home;
